<template>
  <div>
    <div class="header_wrap">
      <div style="width: 60%">
        <el-steps style="width: 100%" align-center :active="1">
          <el-step title="海运信息"></el-step>
          <el-step title="增值服务"></el-step>
          <el-step title="托运信息"></el-step>
          <el-step :title="$t('i18n_confirm_order')"></el-step>
          <el-step :title="$t('i18n_order_completed')"></el-step>
        </el-steps>
      </div>
    </div>
    <!-- --------------------------------内容 -->
    <div class="center_wrap">
      <div class="wrap_l">
        <div style="display: flex; display: -webkit-flex; align-items: center">
          <img src="../../assets/style.png" alt="" />
          <p
            style="
              font-size: 20px;
              font-family: PingFang SC;
              font-weight: 500;
              color: #333333;
              margin-left: 10px;
            "
          >
            增值服务
          </p>
        </div>
        <div class="Item_list" v-for="(item, index) in formData" :key="index">
          <div style="width: 100%">
            <el-checkbox v-model="item.checked">{{ item.feeName }}</el-checkbox>
          </div>
          <div class="LR_center" style="width: 100%; float: left" v-show="item.checked">
            <div class="count_center" style="padding: 25px 25px 0 25px; box-sizing: border-box"
            >
              <div v-show="item.feeCode != 'COD'">
                <span style="float: left" v-if="item.feeCode != 'CLEF'">￥{{ item.cnyprice }}</span>
                <div v-if="item.feeCode == 'CLEF'" style="padding-top: 5px;">
                    <div class="">
                      <test class="">基础操作：{{item.currency}}{{item.basePrice}}</test>
                    </div>
                    <div class="">
                      <test class="">报关单份：{{item.currency}}{{item.declarePrice}}</test>
                    </div>
                </div>
              </div>
              
              <div style="float: left" v-show="item.feeCode == 'COD'">
                <el-input
                  style="width: 130px"
                  size="mini"
                  type="number"
                  v-model="item.price"
                  placeholder="请输入金额"
                  @change="changeinput(item)"
                ></el-input>
              </div>
              <div
                v-show="item.feeCode == 'COD'"
                class="centerstyle"
                style="
                  float: left;
                  width: 100px;
                  margin-left: 5px;
                  margin: 0 15px;
                "
              >
                <el-select
                  size="mini"
                  @change="changemoney(showMoneythst.rate)"
                  v-model="showMoneythst.rate"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="_item in moneytype"
                    :key="_item.rate"
                    :label="_item.currencyTo"
                    :value="_item.rate"
                    >{{ _item.currencyTo }}</el-option
                  >
                </el-select>
              </div>
              <div
                style="float: left; margin-left: 15px"
                v-show="item.feeCode != 'COD'"
              >
                <el-input-number
                  size="mini"
                  v-model="item.piece"
                  @change="handleChange1(item)"
                  :min="1"
                  :max="999"
                ></el-input-number>
              </div>
              <div style="margin-left:10px">
                {{item.feeUnit}}
              </div>
            </div>

            <div style="padding: 25px 0px 0 25px; box-sizing: border-box">
              预估费用：￥{{ item.cnyamount }}
            </div>
          </div>
          <div style="float: right;color: #ccc;" v-if="item.feeCode=='CLEF'&item.checked">
                *续页会产生额外续页费{{item.currency}}{{item.remark}}/{{item.feeUnit}}
            </div>
        </div>
        <div v-show="formData.length == 0" style="padding: 20px">
          <el-alert
            :closable="false"
            title="该线路暂无增值服务"
            type="warning"
            description="该线路暂无增值服务，请点击下一步继续操作"
            show-icon
          >
          </el-alert>
        </div>
      </div>
      <div class="wrap_R" :class="auto_fixed ? 'auto_fixed' : ''">
        <p
          style="
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #343434;
          "
        >
          {{$t('i18n_cost_calculation')}}
        </p>
        <div class="OrderDetails">
          <div class="Item_Right animate__animated animate__bounceInRight">
            <p class="tit">海运费</p>
            <p
            class="coutText"
            v-for="(item, index) in HYFmoney.goodsTypeFeeDTOS"
            :key="index"
          >
            <span class="littit">{{ item.goodsTypeName }}</span>
            <span class="fontString">{{ item.currency }}{{ item.amount }}</span>
            <span style="margin-left:10px">({{item.calDesc}})</span>
          </p>
          <p class="coutText">
            <span class="littit">{{$t('i18n_subtotal')}}</span>
            <span class="fontString"
              >{{ HYFmoney.currency }}{{ HYFmoney.amount }}</span
            >
          </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="tuoCheData.checked"
          >
            <p class="tit">提货费<span v-if="tuoCheData.minKilometer" style="font-size:13px;float: right;font-weight: 500;">({{tuoCheData.minKilometer+'KM'}}--{{tuoCheData.maxKilometer+'KM'}})</span></p>
            <p class="coutText">
              <span class="littit">发货地上门提货</span>
              <span class="fontString"
                >{{ tuoCheData.currency }}{{ tuoCheData.amount }}</span
              >
            </p>
          </div>
          <div
            class="Item_Right animate__animated animate__bounceInRight"
            v-show="PSFmoney.checked"
          >
            <p class="tit">配送费</p>
            <p class="coutText">
              <span class="littit">目的地送货上门</span>
              <span class="fontString"
                >{{ PSFmoney.currency }}{{ PSFmoney.amount }}</span
              >
            </p>
          </div>
          <div class="Item_Right">
            <p class="tit">增值服务费</p>
            <div
              class="coutText animate__animated animate__bounceInRight"
              v-for="(item, index) in formData"
              :key="index"
              v-show="item.checked"
            >
              <span class="littit">{{ item.feeName }}</span>
              <span class="fontString">{{ item.currency }}{{ item.amount }}
                <span v-if="item.feeCode=='CLEF'">({{item.basePrice}}+{{item.cnycontinuationPrice}}*{{item.piece}}</span>
                <span v-else>({{ item.piece }}*{{item.price}}</span>
                <span class="fontString" v-show="item.feeUnit">{{item.feeUnit}}</span>)</span>
            </div>
          </div>
          <div class="Item_Right">
            <p class="coutText">
              <span class="littit">合计费用</span>
              <span
                v-for="(item, index) in this.newArray"
                :key="index"
                v-show="item.amount > 0"
              >
                <span
                  ><span class="fontString" v-show="item.currency != ''">{{
                    item.currency
                  }}</span>
                  <span
                    class="fontString"
                    v-show="item.amount > 0"
                    style="margin-left: 5px; margin-right: 5px"
                    >{{ item.amount }}</span
                  ></span
                >
                <span v-show="index == newArray.length - 1 ? false : true"
                  >+</span
                >
              </span>
            </p>
            <p class="coutText">
              <span class="littit">折合人民币</span>
              <span class="fontString">CNY {{ calculatePrice }}</span>
            </p>
          </div>
        </div>
        <div style="width: 100%; margin-top: 30px; float: left">
          <div style="width: 100%">
            <el-button style="width: 100%" @click="pathToback()"
              >上一步</el-button
            >
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              @click="pathToNext()"
              style="width: 100%; background: #604aff; color: #ffffff"
              >下一步</el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      moneytype: [],
      formData: [],
      auto_fixed: false,
      showMoneythst: {
        //当前展示币种
        currencyTo: "",
        rate: "",
      },
      Citydata: null,
      cangkuitem: null,
      guojiaData: null,
      HYFmoney: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS:[],
      },
      PSFmoney: {
        checked: true,
        name: "配送费",
        feeCode: "SDYF",
        feeType: "A",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      msgFormSon: {},
      newTihuoarr: "", //需展示的提货地址
      todoordate: {},
      tuoCheData: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        minKilometer:'',
        maxKilometer:'',
      },
    };
  },
  watch: {},
  computed: {
    calculatePrice() {
      //计算总费用
      let Totalmoney = 0; //总费用
      let PSFmoney = 0; //配送费
      let HYFmoney = 0; //海运费
      let THFmoney = 0; //提货费
      let feemoney = 0; //增值服务
      this.formData.forEach((item) => {
        if (item.checked) {
          feemoney += Number(item.cnyamount);
        }
      });
      if (this.PSFmoney.checked) {
        //如果有配送费
        PSFmoney = this.PSFmoney.cnyamount ? +this.PSFmoney.cnyamount : 0;
      }
      if (this.tuoCheData.checked) {
        //如果有提货费
        THFmoney = this.tuoCheData.cnyamount ? +this.tuoCheData.cnyamount : 0;
      }
      HYFmoney = this.HYFmoney.cnyamount ? +this.HYFmoney.cnyamount : 0;
      Totalmoney = PSFmoney + HYFmoney + THFmoney + feemoney;
      return Totalmoney.toFixed(2);
    },
    newArray() {
      //监听 币种
      let monetTypelist = []; //当前勾选的币种
      let totalMolist = []; //新对象
      let totalFeiyong = []; //当前勾选
      totalFeiyong.push(JSON.parse(JSON.stringify(this.HYFmoney))); //海运费币种
      if (this.PSFmoney.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.PSFmoney))); //配送费币种
      }
      if (this.tuoCheData.checked) {
        totalFeiyong.push(JSON.parse(JSON.stringify(this.tuoCheData))); //提货费费币种
      }
      this.formData.forEach((item) => {
        if (item.checked) {
          totalFeiyong.push(JSON.parse(JSON.stringify(item)));
        }
      });
      let newArray = totalFeiyong.reduce((total, cur, index) => {
        let hasValue = total.findIndex((current) => {
          return current.currency === cur.currency;
        });
        hasValue === -1 && total.push(cur);
        hasValue !== -1 &&
          (total[hasValue].amount = this.accAdd(
            total[hasValue].amount,
            cur.amount
          ));
        return total;
      }, []);
      return newArray;
    },
  },
  methods: {
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    pathToNext() {
      let that = this;
      let flag = null;
      if (this.formData.length > 0) {
        try {
          this.formData.forEach(function (item, index) {
            if (item.feeCode == "COD" && item.checked) {
              if (item.price == "" || item.price == null||item.price<=0) {
                flag = false;
                 that.$message("请输入代收货款金额");
                throw new Error("EndIterative");
              }
              localStorage.setItem(
                "currencyTo",
                JSON.stringify(that.showMoneythst.currencyTo)
              );
            }else{
              flag = true;
            }
          });
        } catch (e) {
          console.log(e.message);
          if (e.message == "EndIterative") {
            flag = false;
          }
        }
      }else{
        flag = true;
      }
      
      localStorage.setItem("FeeLIst", JSON.stringify(this.formData)); //配送费
      if (flag) {
        this.$router.push({
          name: "Consignment",
        });
      }
    },
    handleChange1(item) {
      console.log(item)
      item.cnyamount =this.$Setnum.NumMul(item.piece,item.cnyprice)  //rmb总费用
      item.amount = this.$Setnum.NumMul(item.piece,item.price)//总费用
      if(item.minCharge){//最低收费
        if(item.amount<item.minCharge){
          item.amount = item.minCharge
        }
        if(item.cnyamount<item.cnyMinCharge){
          item.cnyamount = item.cnyMinCharge
        }
      }
      if(item.maxCharge){//最高收费
        if(item.amount>item.maxCharge){
          item.amount = item.maxCharge
        }
        if(item.cnyamount>item.cnyMaxCharge){
          item.cnyamount = item.cnyMaxCharge
        }
      }
      

      if (item.feeCode == "CLEF") {
        item.amount = this.accAdd(
          item.price,this.$Setnum.NumMul(item.continuationPrice ,(+item.piece - 1))
        );
        item.cnyamount = this.accAdd(
          item.cnyprice,this.$Setnum.NumMul(item.cnycontinuationPrice ,(+item.piece - 1))
        );
      }
    },
    accAdd(arg1, arg2) {
      //加法精度
      var r1, r2, m;
      try {
        r1 = arg1.toString().split(".")[1].length;
      } catch (e) {
        r1 = 0;
      }
      try {
        r2 = arg2.toString().split(".")[1].length;
      } catch (e) {
        r2 = 0;
      }
      m = Math.pow(10, Math.max(r1, r2));
      return (arg1 * m + arg2 * m) / m;
    },
    cnysetamount(rate, total) {
      return rate * total * this.showMoneythst.rate; //当前选择币种的汇率 例如迪拉姆：1.89
    },
    setamount(rate, total) {
      return rate * total;
    },
    changeinput(item) {
      console.log(item); //代收货款时输入的值  第一个参数为当汇率,第二个是输入的金额
      this.formData.forEach((item, index) => {
        if (item.feeCode == "COD") {
          if(item.price<0){item.price = 0}
          item.amount = this.setamount(+item.rate, +item.price).toFixed(2);
          item.cnyamount = this.cnysetamount(+item.rate, +item.price).toFixed(2);
        }
      });
    },
    changemoney(moneyrate) {
      //重新计算费率
      let MoneyItem = {};
      this.moneytype.find((item) => {
        if (item.rate == moneyrate) {
          MoneyItem = item;
        }
      });
      this.showMoneythst.rate = moneyrate; //币种的汇率
      console.log(this.showMoneythst.rate);
      this.formData.forEach((item, index) => {
        if (item.feeCode == "COD") {
          item.amount = this.setamount(+item.rate, +item.price).toFixed(2);
          item.cnyamount = this.cnysetamount(+item.rate, +item.price).toFixed(
            2
          );
          item.currency = MoneyItem.currencyTo;
        }
      });
      this.showMoneythst.currencyTo = MoneyItem.currencyTo;
    },
    pathToback() {
      this.$router.go(-1);
    },
    getShowcount() {
      let that = this;
      let params = {};
      params = {
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        inWarehouseId: JSON.parse(localStorage.getItem("cangkuitem")).id,
      };
      this.axios
        .post(`/feeitem/getAllFeeItems`, params)
        .then((res) => {
          console.log(res);
          if (res.data.code == "200") {
            if (JSON.parse(localStorage.getItem("FeeLIst"))) {
              that.formData = JSON.parse(localStorage.getItem("FeeLIst"));
            } else {
              that.formData = res.data.datas;
              that.formData.forEach((item, index) => {
                that.$set(item, "checked", false);
                that.$set(item, "piece", 1);
                that.$set(item, "cnyamount", 0);
                that.$set(item, "amount", 0);
                item.cnyamount = item.piece * item.cnyprice;
                item.amount = item.piece * item.price;
              });
            }
            this.getMoneyType(); //获取币种
          } else {
          }
        })
        .catch((res) => {
          console.log(res);
        });
    },
    getMoneyType() { //获取币种及汇率
      let that = this;
      this.axios
        .post(`/feeitem/getExchangeRateList`)
        .then((res) => {
          console.log(res);
          if (res.status == "200") {
            this.moneytype = res.data.datas;
            if (localStorage.getItem("currencyTo")) {that.showMoneythst.currencyTo = JSON.parse(localStorage.getItem("currencyTo"));
              res.data.datas.forEach((item) => {
                if (
                  JSON.parse(localStorage.getItem("currencyTo")) == item.currencyTo
                ) {
                  that.showMoneythst.rate = item.rate; // 如果有记录就等于老的汇率
                }
              });
            } else {
              that.showMoneythst.currencyTo = res.data.datas[0].currencyTo;
              that.formData.forEach((item) => {
                if (item.feeCode == "COD") {
                  // if (item.currency == null) {
                  //   item.currency = res.data.datas[0].currencyTo;
                  // }
                  item.currency = res.data.datas[0].currencyTo;
                }
              });
              that.showMoneythst.rate = res.data.datas[0].rate;
            }
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    onScroll() {
      // 计算滚动的距离
      let scrolled =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 计算A区的高度
      let header_height = null;
      if (document.getElementsByClassName("wrap_R")[0]) {
        header_height = document.getElementsByClassName("wrap_R")[0]
          .offsetHeight;
      }
      if (scrolled >= 200) {
        this.auto_fixed = true;
      } else {
        this.auto_fixed = false;
      }
    },
  },
  created() {
    this.Citydata = JSON.parse(localStorage.getItem("Citydata"));
    this.cangkuitem = JSON.parse(localStorage.getItem("cangkuitem"));
    this.guojiaData = JSON.parse(localStorage.getItem("guojiaData"));
    if (localStorage.getItem("HYFmoney")) {
      //海运费
      this.HYFmoney = JSON.parse(localStorage.getItem("HYFmoney"));
    }
    if (JSON.parse(localStorage.getItem("PSFmoney"))) {
      //配送费
      this.PSFmoney = JSON.parse(localStorage.getItem("PSFmoney"));
    }
    if (localStorage.getItem("todoordate")) {
      //提货费
      this.tuoCheData = JSON.parse(localStorage.getItem("todoordate"));
    }
  },
  mounted() {
    this.getShowcount();
    this.$nextTick(function () {
      //监听滚动
      window.addEventListener("scroll", this.onScroll);
    });
  },
};
</script>
<style scoped>
.fontString {
  font-weight: bold;
}
.auto_fixed {
  position: fixed;
  top: 20px;
  margin-left: 778px;
}
/* 左右对齐 */
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
/* 垂直居中 */
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
}
.table_wrap >>> .el-dialog__body {
  padding: 0 15px !important;
}

.Item_Right {
  float: left;
  overflow-x: hidden;
}
.Item_Right .tit {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #343434;
}
.littit {
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
}

.coutText {
  margin-top: 9px;
  font-size: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  overflow-x: hidden;
}
.Item_Right {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.Iteminput {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  margin-bottom: 15px;
  color: #909399;
}
.center_wrap {
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  float: left;
  padding: 15px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #e7e7e7;
}
.header_wrap {
  width: 100%;
  height: 121px;
  margin-top: 33px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
.wrap_l {
  float: left;
  width: 764px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 35px;
  box-sizing: border-box;
}
.wrap_R {
  float: right;
  width: 320px;
  background: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 10px;
  padding: 20px;
  box-sizing: border-box;
}
.cangkutit {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #343434;
  float: left;
}
/* table 滚动条 */
.OrderDetails {
  max-height: 500px;
  overflow: auto;
  overflow-x: hidden;
}
.OrderDetails::-webkit-scrollbar {
  width: 3px;
}
.OrderDetails::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #409eff;
}
.OrderDetails::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: #eee;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/newservice.vue